import React from 'react';
import { InputAdornment } from '@material-ui/core';
import { Controller } from 'react-hook-form';

import TextField from '../../components/TextField';

const FieldController = ({
  name = '',
  textFieldProps = {},
  optional = false,
  children = () => null,
  ...props
}) => {
  return (
    <Controller
      name={name}
      render={({
        field,
        fieldState: { error, isTouched, isDirty },
        fieldState,
        formState,
      }) => {
        const optionalTextFieldProps = {
          showValidationDefault: !(optional && !field.value),
          renderEndAdornment: !(optional && !field.value)
            ? ({ errorAndSuccessComponents }) => (
                <InputAdornment position="end">
                  {errorAndSuccessComponents}
                </InputAdornment>
              )
            : () => null,
        };

        const component = !!children
          ? children({
              field,
              fieldState,
              formState,
              isError: !!error?.message,
              touched: isDirty && isTouched,
              helperText: error?.message,
              optionalTextFieldProps,
            })
          : null;

        return React.isValidElement(component) ? (
          component
        ) : (
          <TextField
            {...field}
            error={!!error?.message}
            touched={isDirty && isTouched}
            helperText={error?.message}
            {...optionalTextFieldProps}
            {...textFieldProps}
          />
        );
      }}
      {...props}
    />
  );
};

export default FieldController;
